import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { sortBy } from 'lodash';
import { titleize } from 'underscore.string';
import CustomerSearch from 'components/site/customer-search';
import CargomaticBadge from 'components/v2/Badge';
import CargomaticInput from 'components/v2/input';
import CargomaticAlert from 'components/ui/Alert';
import Spinner from 'components/ui/Spinner';
import SplitIcon from 'components/v2/icons/SplitIcon';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';
import { getShipmentDetailUrl } from 'utils/formatters/shipments';
import { useTranslation } from 'react-i18next';
import PanelSection from 'components/v2/PanelSection';
const SplitShipment = (props) => {
    const { shipmentId, originJob, newJob, onCancel } = props;
    const [carrierToAssign, setCarrierToAssign] = useState(null);
    const [removeCarrierCost, setRemoveCarrierCost] = useState(false);
    const [removeShipperCost, setRemoveShipperCost] = useState(false);
    const [includeCarrierCostOnNew, setIncludeCarrierCostOnNew] = useState(false);
    const [includeShipperCostOnNew, setincludeShipperCostOnNew] = useState(false);
    const [shipmentCreated, setShipmentCreated] = useState(null);
    const [isSplitting, setIsSplitting] = useState(false);
    const { t } = useTranslation();
    useEffect(() => { }, [originJob, newJob]);
    const INPUT_MESSAGES = {
        REMOVE_CARRIER: t('REMOVE_CARRIER_MESSAGE'),
        REMOVE_SHIPPER: t('REMOVE_SHIPPER_MESSAGE'),
        INCLUDE_CARRIER_ON_NEW: t('INCLUDE_CARRIER_ON_NEW_MESSAGE'),
        INCLUDE_SHIPPER_ON_NEW: t('INCLUDE_SHIPPER_ON_NEW_MESSAGE'),
    };
    const STOP_INTENTS = {
        PICKUP: 'pickup',
        DELIVER: 'deliver',
    };
    const resetFields = () => {
        setCarrierToAssign(null);
        setRemoveCarrierCost(false);
        setRemoveShipperCost(false);
        setIncludeCarrierCostOnNew(false);
        setincludeShipperCostOnNew(false);
        setIsSplitting(false);
    };
    const splitShipment = async () => {
        const payload = {
            stops: newJob.stops.map((stop) => stop._id.toString()),
            carrier: carrierToAssign ? carrierToAssign._id : null,
            actions: {
                remove_carrier_cost: removeCarrierCost,
                remove_shipper_cost: removeShipperCost,
                include_carrier_cost_on_new: includeCarrierCostOnNew,
                include_shipper_cost_on_new: includeShipperCostOnNew,
            },
        };
        setIsSplitting(true);
        const response = await ShipmentWebAPIUtils.splitShipment(shipmentId, payload).catch((e) => {
            console.log(e);
        });
        if (response.success) {
            const { shipment_id, _id } = response.job;
            setShipmentCreated({ shipmentId: shipment_id, _id });
            setTimeout(onCancel, 8000);
            setTimeout(() => setShipmentCreated(null), 8000);
        }
        resetFields();
    };
    const renderSuccess = () => {
        return (React.createElement(CargomaticAlert, { type: "success", canDelete: true, onDelete: () => setShipmentCreated(null) },
            t('SPLIT_SHIPMENT_SUCCESS'),
            React.createElement(Link, { id: "new-shipment-link", to: getShipmentDetailUrl(shipmentCreated._id), target: "_blank" }, shipmentCreated.shipmentId),
            ' '));
    };
    const getCheckbox = (message, checked, onChange) => {
        return (React.createElement("div", { className: "flex cursor-pointer", onClick: onChange },
            React.createElement(CargomaticInput, { type: "checkbox", onChange: onChange, checked: checked }),
            React.createElement("p", { className: "pl-2" }, message)));
    };
    const getAddressInfo = (stop) => {
        if (!stop || !stop.location) {
            return null;
        }
        return (React.createElement("div", { className: "flex flex-col" },
            React.createElement("p", null, stop.location[0].name),
            React.createElement("p", null, stop.location[0].display_address)));
    };
    const getStop = (stop) => {
        const { action, off_site, empty } = stop;
        const getAction = () => {
            if (action === STOP_INTENTS.PICKUP) {
                if (empty) {
                    return t('PICKUP_EMPTY');
                }
                return t('PICKUP');
            }
            if (empty) {
                return t('DELIVERY_EMPTY');
            }
            return t('DELIVERY');
        };
        return (React.createElement("div", { id: stop._id, className: "w-5/6 my-4" },
            React.createElement("div", { className: "flex justify-between" },
                React.createElement("p", null, titleize(getAction())),
                React.createElement("div", { className: "w-3/4 flex flex-col" },
                    getAddressInfo(stop),
                    off_site ? (React.createElement(CargomaticBadge, { className: "my-2", color: "blue", text: t('OFFSITE_STOP') })) : null))));
    };
    const getShipment = ({ stops, carrier }, allowAssignCarrier, count = 1) => {
        const getCarrierField = () => {
            if (carrier) {
                return React.createElement("p", null, carrier.name);
            }
            if (!allowAssignCarrier) {
                return null;
            }
            return (React.createElement(CustomerSearch, { onSelect: (_item, data) => setCarrierToAssign(data), placeholder: t('ASSIGN_A_CARRIER'), type: "carrier", authorizedOnly: true }));
        };
        const sortedStops = sortBy(stops, (stop) => stop.sequence);
        return (React.createElement("div", null,
            React.createElement("p", { className: "font-semibold my-2" }, t('SHIPMENT_COUNT', { shipmentCount: count })),
            React.createElement("div", { className: "w-5/6 h-12 flex my-2" },
                React.createElement("p", { className: "w-1/4" }, titleize(t('CARRIER'))),
                React.createElement("div", { className: "flex" },
                    getCarrierField(),
                    allowAssignCarrier && carrierToAssign && (React.createElement(CargomaticBadge, { className: "pl-2 my-auto", color: "blue", text: carrierToAssign.name })))),
            sortedStops.map((stop) => getStop(stop))));
    };
    return (React.createElement(PanelSection, { className: "flex flex-col" },
        React.createElement("h4", { className: "flex pb-2" }, t('VERIFY_SPLIT')),
        React.createElement("div", { className: "flex" },
            React.createElement("div", { className: "w-2/5" },
                React.createElement("div", { className: "pl-8 mx-auto" },
                    getShipment(originJob, false),
                    React.createElement("div", { className: "my-8" },
                        getCheckbox(INPUT_MESSAGES.REMOVE_CARRIER, removeCarrierCost, () => setRemoveCarrierCost(!removeCarrierCost)),
                        getCheckbox(INPUT_MESSAGES.REMOVE_SHIPPER, removeShipperCost, () => setRemoveShipperCost(!removeShipperCost))))),
            React.createElement("div", { className: "1/5 my-auto mx-auto pr-16" },
                React.createElement("div", { className: "p-4 rounded-full bg-gray-300" },
                    React.createElement(SplitIcon, { color: "#38495c", className: "w-8 h-8" }))),
            React.createElement("div", { className: "w-2/5" },
                React.createElement("div", { className: "pl-8 mx-auto" },
                    getShipment(newJob, true, 2),
                    React.createElement("div", { className: "my-8" },
                        getCheckbox(INPUT_MESSAGES.INCLUDE_CARRIER_ON_NEW, includeCarrierCostOnNew, () => setIncludeCarrierCostOnNew(!includeCarrierCostOnNew)),
                        getCheckbox(INPUT_MESSAGES.INCLUDE_SHIPPER_ON_NEW, includeShipperCostOnNew, () => setincludeShipperCostOnNew(!includeShipperCostOnNew)))))),
        React.createElement("div", { className: "py-4" },
            React.createElement("div", { className: "flex flex-row justify-end" },
                React.createElement("button", { className: "button button-red mr-2", onClick: onCancel }, titleize(t('CANCEL'))),
                React.createElement("button", { className: "button button-green", disabled: isSplitting || !!shipmentCreated, onClick: splitShipment }, isSplitting ? React.createElement(Spinner, { message: t('SPLITTING') }) : t('CONTINUE'))),
            React.createElement("div", { className: "flex flex-row justify-end py-4" }, shipmentCreated && renderSuccess()))));
};
export default SplitShipment;
